<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Torneo</label>
                <select
                  v-model="filters.tournamentId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                  @change="getMatchesByTournament()"
                >
                  <option :value="0">{{ LABELS.SELECT }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsTournament"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Partido</label>
                <select
                  v-model="filters.matchId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                  @change="getTeamsByTournament()"
                >
                  <option :value="0">{{ LABELS.SELECT }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsMatch"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Equipo</label>
                <select
                  v-model="filters.teamId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                  @change="onChangeTeam"
                >
                  <option :value="0">{{ LABELS.SELECT }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsTeam"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4 position-relative">
                <label class="label text-secondary">Nombre del Jugador</label>
                <input
                  v-model="filters.name"
                  @input="fetchResults"
                  type="text"
                  class="form-control"
                  placeholder="Escribe para buscar jugadores..."
                />
                <ul
                  v-if="showDropdown && results.length"
                  class="dropdown-menu show w-100 mt-1"
                  style="top: 100%; left: 0"
                >
                  <li
                    v-for="item in results"
                    :key="item.id"
                    class="dropdown-item"
                    @click="selectItem(item)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-2 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button
                  type="button"
                  @click.prevent="getPlays(currentPage)"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Jugador</th>
                <th scope="col" class="text-center">Jugada</th>
                <th scope="col" class="text-center">Estado</th>
                <th scope="col" class="text-center">
                  Creado<br />
                  por
                </th>
                <th scope="col" class="text-center">Fecha <br />creación</th>
                <th scope="col" class="text-center">Modificado <br />por</th>
                <th scope="col" class="text-center">
                  Fecha <br />
                  modificación
                </th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 + (currentPage - 1) * pageSize }}
                </td>
                <td class="text-body">{{ item.player }}</td>
                <td class="text-body">{{ item.play }}</td>
                <td class="text-body text-center">
                  <span
                    @click="confirmChangeStatus(item.id, item.isActive)"
                    class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                    role="button"
                    :class="computeStatusClass(item.isActive)"
                  >
                    {{ item.isActive ? STATUS.ACTIVE : STATUS.INACTIVE }}
                  </span>
                </td>
                <td class="text-body">{{ item.createdBy }}</td>
                <td class="text-body">{{ item.createdAtDateTimeString }}</td>
                <td class="text-body">{{ item.updatedBy }}</td>
                <td class="text-body">{{ item.updatedAtDateTimeString }}</td>
                <td class="text-center">
                  <div class="">
                    <button
                      class="ps-2 border-0 bg-transparent lh-1 position-relative"
                      @click="contentModal(item)"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        settings
                      </i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalItems="totalItems"
            @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Contenido-->
  <div
    id="mdlContenido"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlContenidoLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    size="large"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlContenidoLabel">
            Jugada {{ objContent.play }}
          </h1>
          <button
            type="button"
            class="btn-close"
            @click="closeModal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="position-relative mb-3"></div>
          <div class="default-table-area style-two default-table-width">
            <div class="table-responsive">
              <div v-if="objContent.contentFileName != ''">
                <img v-if="!objContent.isPDF"
                  :src="objContent.contentFileName"
                  class="img-fluid mb-2 d-block"
                />
                <iframe v-else                 
                  :src="objContent.contentFileName"
                  width="100%"
                  height="700px"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            @click="closeModal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
import api from "@/services/api";
import { PAGINATION_ITEMS_PER_PAGE, STATUS, LABELS } from "@/utils/constants";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "PlaysContent",
  components: {
    Pagination,
    OverlayLoader,
  },
  setup() {
    const isLoading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();

    const itemsTournament = ref<any[]>([]);
    const itemsMatch = ref<any[]>([]);
    const itemsTeam = ref<any[]>([]);
    const items = ref<any[]>([]);
    const modalContent = ref<any>(null);
    let timeout: number;
    const results = ref<any[]>([]);
    const showDropdown = ref(false);
    const filters = ref({
      name: "",
      tournamentId: 0,
      matchId: 0,
      teamId: 0,
      playerId: 0,
    });
    const objContent = ref({
      id: 0,
      play: "",
      contentFileName: "",
      isPDF: false,
    });

    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };

    onMounted(async () => {
      await getTournaments();
      //await getPlays(currentPage.value);
      const mdlContenido = document.getElementById("mdlContenido");
      if (mdlContenido && window.bootstrap) {
        modalContent.value = new window.bootstrap.Modal(mdlContenido);
        modalContent.value.hide();
      }
    });

    const getTournaments = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        const response = await api.get(`/tournament?${params}`);

        itemsTournament.value = response.data.list;
        getPlaysDefault();
      } catch (error) {
        console.error(error);
      }
    };

    const getMatchesByTournament = async () => {
      try {
        itemsMatch.value = [];
        itemsTeam.value = [];
        filters.value.matchId = 0;
        filters.value.teamId = 0;
        filters.value.name = "";
        filters.value.playerId = 0;

        var params = `pageNumber=1&pageSize=99999&isActive=true`;
        params = params + `&tournamentId=${filters.value.tournamentId}`;

        const response = await api.get(`/match?${params}`);

        itemsMatch.value = response.data.list;
        getPlaysDefault();
      } catch (error) {
        console.error(error);
      }
    };

    const getTeamsByTournament = async () => {
      try {
        itemsTeam.value = [];
        filters.value.teamId = 0;
        filters.value.name = "";
        filters.value.playerId = 0;

        var params = `&tournamentId=${filters.value.tournamentId}`;
        params = params + `&matchId=${filters.value.matchId}`;
        const response = await api.get(`/team/tournament-match-team?${params}`);

        itemsTeam.value = response.data;
        getPlaysDefault();
      } catch (error) {
        console.error(error);
      }
    };
    const onChangeTeam = async () => {
      filters.value.name = "";
      filters.value.playerId = 0;
      getPlaysDefault();
    };
    const fetchResults = () => {
      filters.value.playerId = 0;
      getPlaysDefault();
      clearTimeout(timeout);

      if (!filters.value.name || filters.value.name.length < 2) {
        results.value = [];
        showDropdown.value = false;
        return;
      }

      timeout = window.setTimeout(async () => {
        try {
          const response = await api.get(
            `/player/search/tournament-match-player`,
            {
              params: {
                name: filters.value.name,
                tournamentId: filters.value.tournamentId,
                matchId: filters.value.matchId,
                teamId: filters.value.teamId,
              },
            }
          );

          results.value = response.data;
          showDropdown.value = true;
        } catch (error) {
          console.error("Error fetching data", error);
          showDropdown.value = false;
        }
      }, 300);
    };

    const selectItem = async (item: any) => {
      filters.value.name = item.name;
      filters.value.playerId = item.id;
      showDropdown.value = false;
      getPlaysDefault();
    };
    const getPlaysDefault = async () => {
      items.value = [];
      totalItems.value = 0;
    };
    const getPlays = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.tournamentId) {
          params = params + `&tournamentId=${filters.value.tournamentId}`;
        }
        if (filters.value.matchId) {
          params = params + `&matchId=${filters.value.matchId}`;
        }
        if (filters.value.teamId) {
          params = params + `&teamId=${filters.value.teamId}`;
        }
        if (filters.value.playerId) {
          params = params + `&playerId=${filters.value.playerId}`;
        }

        const response = await api.get(`/query/play_content?${params}`);

        items.value = response.data.list;
        totalItems.value = response.data.rows;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getPlays(currentPage.value);
    };

    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${
          status ? "desactivar" : "activar"
        }</b> el Contenido?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? "desactivar" : "activar"} `,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          id: id,
          status: !status,
        };

        const response: any = await api.put(
          `tournament/player-upload-content/`,
          obj
        );

        if (response != 0) {
          toast.success(
            `El contenido fue ${
              status ? "desactivada" : "activada"
            } con éxito.`,
            {
              timeout: 2000,
            }
          );
          fetchPage(currentPage.value);
        } else {
          toast.error(
            `El contenido no pudo ser ${status ? "desactivada" : "activada"}.`,
            {
              timeout: 2000,
            }
          );
        }
        isLoading.value = false;
      }
    };
    const contentModal = async (item: any) => {
      var pContent = "";
      if (item.contentFileName) {
        pContent = process.env.VUE_APP_API_URL + "/" + item.contentFileName;
      }
      objContent.value = {
        id: item.id,
        play: item.play,
        contentFileName: pContent,
        isPDF: item.contentFileNameExtension
          ? item.contentFileNameExtension.toUpperCase() == ".pdf".toUpperCase()
          : false,
      };

      modalContent.value.show();
    };

    const closeModal = async () => {
      objContent.value.id = 0;
      objContent.value.play = "";
      objContent.value.contentFileName = "";
      modalContent.value.hide();
    };
    return {
      items,
      itemsTournament,
      itemsMatch,
      itemsTeam,
      currentPage,
      pageSize,
      totalItems,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      isLoading,
      computeStatusClass,
      getMatchesByTournament,
      getTeamsByTournament,
      getPlays,
      fetchPage,
      confirmChangeStatus,
      showDropdown,
      results,
      fetchResults,
      onChangeTeam,
      selectItem,
      getPlaysDefault,
      contentModal,
      closeModal,
      objContent,
    };
  },
});
</script>
